import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AddInvoiceNumber from "./addInvoiceNumber";
import { locationPinCode,shipTolocationPinCode } from "services/redux/sales/corporate/locations/action";
import { postInvoiceNumber } from "services/redux/sales/postSales/action";
import { clientBillingAddress } from "services/redux/sales/corporate/client/action";
import {
  contractApartment,
  contractCorporate,
  contractSupply,
  getMateriaById,
  getBrandById,
  getTagById,
} from "services/redux/sales/postSales/contractCorporate/action";
import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";
import { supplyNameFun } from "services/redux/sales/corporate/categoryDetails/action";

const mapStateToProps = (state) => ({
  contractAptData: state.contractCorporateReducer.contractAptData,
  contractCorpData: state.contractCorporateReducer.contractCorpData,
  contractSupplyData: state.contractCorporateReducer.contractSupplyData,
  pincodeData: state.locationReducer.pincodeData,
  getMaterial: state.contractCorporateReducer.getMaterial,
  getBrand: state.contractCorporateReducer.getBrand,
  getTag: state.contractCorporateReducer.getTagById,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  splNameData: state.categoryDetlReducer.splNameData,
  shipToPincodeData:  state.locationReducer.shipToPincodeData,
  clientBillingPocData: state.clientReducer.billingAddressPoc
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      contractApartment,
      contractCorporate,
      contractSupply,
      locationPinCode,
      postInvoiceNumber,
      getMateriaById,
      getTagById,
      documentUploadUrl,
      imageUploadUrl,
      videoUploadUrl,
      supplyNameFun,
      shipTolocationPinCode,
      clientBillingAddress
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddInvoiceNumber);
